import { render, staticRenderFns } from "./ModalExibirEnqueteNaTarja.vue?vue&type=template&id=2b3dbb14"
import script from "./ModalExibirEnqueteNaTarja.vue?vue&type=script&lang=js"
export * from "./ModalExibirEnqueteNaTarja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports